import { Job } from "@/types/career";
import { throwForFailedResponse } from "@/lib/errors/error-handler";

type JobQuery = {
  slug?: string;
  search?: string;
  department?: string;
  location?: string;
  employment_type?: string;
  order_by?: "created_at" | "title";
  order_direction?: "asc" | "desc";
};

async function getJson<T>(path: string) {
  const res = await fetch(path, { method: "GET", credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.success === false) {
    throwForFailedResponse(res, data, "Request failed");
  }
  return (data?.data ?? data) as T;
}

export const jobService = {
  async list(params: JobQuery = {}): Promise<Job[] | Job> {
    if (params.slug) {
      const qs = new URLSearchParams();
      qs.set("slug", params.slug);
      return getJson<Job>(`/api/job?${qs.toString()}`);
    }

    const qs = new URLSearchParams();
    if (params.search) qs.set("search", params.search);
    if (params.department) qs.set("department", params.department);
    if (params.location) qs.set("location", params.location);
    if (params.employment_type) qs.set("employment_type", params.employment_type);
    qs.set("order_by", params.order_by ?? "created_at");
    qs.set("order_direction", params.order_direction ?? "asc");

    return getJson<Job[]>(`/api/job?${qs.toString()}`);
  },

  async submitJobApplication(formData: FormData): Promise<void> { 
    const res = await fetch(`/api/job/apply`, {
      method: "POST",
      body: formData,
    });

    const data = await res.json().catch(() => ({}));
      if (!res.ok || data?.success === false) {
        throwForFailedResponse(res, data, "Failed to create");
      }
    return data?.data ?? data;
  }
};
